module.exports = __webpack_public_path__ + "static/media/CSV_exampleImage.dacaafcf.jpg";